import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, Input } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import classnames from 'classnames';

//SimpleBar
import SimpleBar from "simplebar-react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { userOutletUpdate } from "../../store/actions";

const OutletDropdown = (props) => {
    const dispatch = useDispatch();
    let history = useHistory();
    //Dropdown Toggle
    const [isOutletDropdown, setIsOutletDropdown] = useState(false);
    const [searchText, setSearchText] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const toggleOutletDropdown = () => {
        setIsOutletDropdown(!isOutletDropdown);
    };
    const selectedGroup = (localStorage.getItem('analyticsGroup') ? JSON.parse(localStorage.getItem('analyticsGroup')) : null);

    const { user, currentOutlet, userOutlets, userGroups, userUnits } = useSelector(state => {
        return {
            user: state.Profile.user,
            currentOutlet: state.UserOutletGroup.currentOutlet,
            userOutlets: state.UserOutletGroup.userOutlets,
            userGroups: state.UserOutletGroup.userGroups,
            userUnits: state.UserOutletGroup.userUnits,
        };
    });

    useEffect(() => {
        setOutletList(Object.values(userOutlets));
    }, [userOutlets]);

    useEffect(() => {
        setGroupList(Object.values(userGroups));
    }, [userGroups]);

    useEffect(() => {
        setUnitList(Object.values(userUnits));
    }, [userUnits]);

    // useEffect(()=>{
    //     if(searchText){
    //         setOutletList(Object.values(userOutlets).filter((outlet)=>outlet.outlet_name.toLowerCase().includes(searchText.toLowerCase())));
    //         setGroupList(Object.values(userGroups).filter((group)=>group.group_name.toLowerCase().includes(searchText.toLowerCase())));
    //         setUnitList(Object.values(userUnits).filter((unit)=>unit.unit_name.toLowerCase().includes(searchText.toLowerCase())));
    //     }else{
    //         setOutletList(Object.values(userOutlets));
    //         setGroupList(Object.values(userGroups));
    //         setUnitList(Object.values(userUnits));
    //     }
    // },[searchText])

    useEffect(() => {
        const sanitizedSearchText = typeof searchText === 'string' ? searchText.toLowerCase() : '';

        if (sanitizedSearchText) {
            setOutletList(Object.values(userOutlets).filter((outlet) =>
                outlet.outlet_name.toLowerCase().includes(sanitizedSearchText)
            ));
            // setGroupList(Object.values(userGroups).filter((group) => 
            //     group.group_name.toLowerCase().includes(sanitizedSearchText)
            // ));
            setUnitList(Object.values(userUnits).filter((unit) =>
                unit.unit_name.toLowerCase().includes(sanitizedSearchText)
            ));
        } else {
            setOutletList(Object.values(userOutlets));
            setGroupList(Object.values(userGroups));
            setUnitList(Object.values(userUnits));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);

    const [userID, setUserID] = useState(false);
    const [outletGroupInfo, setOutletGroupInfo] = useState(null);

    useEffect(() => {
        const obj = getLoggedinUser();
        if (obj) {
            setUserID(user.user_id || obj.user_id || false);
        }
        if (selectedGroup) {
            setOutletGroupInfo('Group - ' + selectedGroup.title);
        } else if (currentOutlet) {
            setOutletGroupInfo(currentOutlet.type + ' - ' + currentOutlet.name);
        }
    }, [currentOutlet, selectedGroup]);
    //Tab 

    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const selectOutlet = (outlet) => {
        localStorage.removeItem('analyticsGroup');
        dispatch(userOutletUpdate({ typeID: outlet.outlet_id, type: 'outlet', userID: userID }, history));
    };

    const selectGroup = (group) => {
        localStorage.setItem('analyticsGroup', JSON.stringify(group));
        window.location.href = '/restaurant-analytics';
        setOutletGroupInfo('Group - ' + group.title);
    };

    const selectUnit = (unit) => {
        dispatch(userOutletUpdate({ typeID: unit.unit_id, type: 'unit', userID: userID }, history));
        setIsOutletDropdown(false);
    };
    if (!outletGroupInfo)
        return;


    function buildGroupTree(groups) {
        const groupMap = {};
        const roots = [];

        // Convert group_ids to string to match parent_id
        groups.forEach(group => {
            group.children = [];
            groupMap[group.group_id] = group;
        });

        groups.forEach(group => {
            if (group.parent_id && group.parent_id !== "0") {
                const parent = groupMap[group.parent_id];
                if (parent) {
                    parent.children.push(group);
                }
            } else {
                roots.push(group);
            }
        });

        return roots; // top-level parents (e.g., areas)
    }


    const getColorByGroupType = (groupType) => {
        switch (groupType) {
            case 'area': return '#d0ebff';
            case 'cluster': return '#d3f9d8';
            case 'location': return '#ffd8a8';
            case 'outlet': return '#ffe3e3';
            default: return '#dee2e6'; // default border
        }
    };

    const deselectGroup = () => {
        localStorage.removeItem('analyticsGroup');
        window.location.href = '/playground';
    };

    const renderGroupTree = (groups, level = 0) => {
        return groups.map(group => {
            // Icon logic based on level
            let iconClass = '';
            if (level === 0) iconClass = 'ri-arrow-right-line';
            else if (level === 1) iconClass = 'ri-arrow-right-s-line';
            else iconClass = 'ri-arrow-drop-right-line';

            // Check if this group is selected
            const isSelected = selectedGroup?.group_id === group.group_id;

            return (
                <React.Fragment key={group.group_id}>
                    <div
                        className={`text-reset d-block dropdown-item position-relative d-flex justify-content-between align-items-center ${isSelected ? 'bg-light text-white' : ''}`}
                        style={{
                            marginLeft: `${level * 12}px`,
                            whiteSpace: 'normal',
                            borderRadius: '6px',
                            padding: '8px',
                            cursor: 'pointer'
                        }}
                        onClick={() => selectGroup(group)} // Move the click handler here
                    >
                        {/* Left section with icon and title */}
                        <div className="d-flex align-items-center">
                            <span className="me-2">
                                <i className={iconClass}></i>
                            </span>
                            <h6 className="mb-0 lh-base" style={{ wordBreak: 'break-word' }}>
                                {group.title}
                            </h6>
                        </div>

                        {/* Deselect icon */}
                        {isSelected && (
                            <i
                                className="ri-close-line"
                                style={{ cursor: 'pointer', paddingRight: '15px' }}
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent parent div click
                                    deselectGroup();
                                }}
                                title="Deselect"
                            ></i>
                        )}
                    </div>


                    {/* Recursive children rendering */}
                    {group.children && group.children.length > 0 && renderGroupTree(group.children, level + 1)}
                </React.Fragment>
            );
        });
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isOutletDropdown} toggle={toggleOutletDropdown} className="ms-3 topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-success">
                    {outletGroupInfo}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0" end={true}>
                    <div className="dropdown-head bg-primary bg-pattern rounded-top">
                        <div className="px-3 pt-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0 fs-16 fw-semibold text-white"> {outletGroupInfo} </h6>
                                </Col>
                            </Row>
                        </div>
                        <div className="p-3 app-search">
                            <div className='position-relative'>
                                <Input
                                    name="search"
                                    type="text"
                                    placeholder="Search"
                                    value={searchText}
                                    onChange={(event) => { setSearchText(event.target.value) }}
                                />
                                <span className="mdi mdi-magnify search-widget-icon"></span>
                            </div>
                        </div>
                        <div className="px-2 pt-2">
                            <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { toggleTab('1'); }}
                                    >
                                        Outlet
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => { toggleTab('2'); }}
                                    >
                                        Group
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '3' })}
                                        onClick={() => { toggleTab('3'); }}
                                    >
                                        Unit
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>

                    </div>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "200px", overflowY: 'auto' }} className="pe-2">
                                {
                                    outletList.length > 0 && outletList.map(function (outlet) {
                                        return <div key={outlet.outlet_id} className="text-reset notification-item d-block dropdown-item position-relative">
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    <Link to="#" className="stretched-link" onClick={() => selectOutlet(outlet)}>
                                                        <h6 className="mt-0 mb-2 lh-base">{outlet.outlet_name}</h6>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </SimpleBar>

                        </TabPane>

                        <TabPane tabId="2" className="py-2 ps-2">
                            {/* <SimpleBar style={{ maxHeight: "200px" }} className="pe-2">
                                {
                                    groupList.length > 0 && groupList.map(function(group){
                                        return <div key={group.group_id} className="text-reset notification-item d-block dropdown-item position-relative">
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    <Link to="#" className="stretched-link" onClick={() => selectGroup(group)}>
                                                        <h6 className="mt-0 mb-2 lh-base">{group.group_name}</h6>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </SimpleBar> */}
                            <SimpleBar style={{ maxHeight: "200px", overflowY: 'auto', overflowX: 'hidden' }} className="pe-2">
                                {renderGroupTree(buildGroupTree(groupList))}
                            </SimpleBar>
                        </TabPane>
                        <TabPane tabId="3" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "200px" }} className="pe-2">
                                {
                                    unitList.length > 0 && unitList.map(function (unit) {
                                        return <div key={unit.unit_id} className="text-reset notification-item d-block dropdown-item position-relative">
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    <Link to="#" className="stretched-link" onClick={() => selectUnit(unit)}>
                                                        <h6 className="mt-0 mb-2 lh-base">{unit.unit_name}</h6>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </SimpleBar>
                        </TabPane>
                    </TabContent>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default OutletDropdown;